import {Component, OnInit} from '@angular/core';
import {ConsultingService, LoaderService, ReportService} from '@app/shared/services';
import {catchError, debounceTime, distinctUntilChanged, map, switchMap, tap} from 'rxjs/operators';
import {Observable, of} from 'rxjs';
import {CommonModule, DatePipe} from '@angular/common';
import {PageHeaderComponent} from '@app/components/page-header/page-header.component';
import {ToastrService} from 'ngx-toastr';
import {FormsModule} from '@angular/forms';
import {NgbHighlight, NgbTypeahead} from '@ng-bootstrap/ng-bootstrap';
import {SelectDropDownModule} from 'ngx-select-dropdown';
import {environment} from '@env/environment';
import {UtilsInjectable} from '@app/shared';

@Component({
  selector: 'app-sale-return',
  templateUrl: './sale-return.component.html',
  styleUrls: ['./sale-return.component.scss'],
  imports: [
    CommonModule,
    FormsModule,
    PageHeaderComponent,
    NgbHighlight,
    SelectDropDownModule,
    NgbTypeahead
  ],
  providers: [DatePipe]
})
export class SaleReturnComponent implements OnInit {

  user_rights: any;
  user_data: any;

  public now = new Date();

  public sale_details: any = [""];
  date: any;
  unit: any;
  purchase_data: any;
  total_amount: any;
  start = 0;
  limit = 10;
  p = 50;
  public collection: any = '';
  page = 1;
  index: any;
  status: any;
  public sale_return: any =
    {
      vendor_id: '',
      sale_details_id: [""],
      invoice_date: '',
      return_date: new Date(),
      reference_no: "",
      return_reason: [""],
      sale_id: 0,
      state: '',
      medicine_data: [],
      medicine_id_arr: [""],
      customer_name: '',
      sale_date: new Date(),
      ava_quantity_arr: [""],
      quantity_arr: [""],
      uom_arr: [""],
      uom_arr_name: [""],
      amount_arr: [""],
      price_arr: [""],
      retailprice_arr: [""],
      dis_arr: [""],
      user_id: '',
      total_arr: [""],
      unitprice_arr: [""],
      return_amt: ["0"],
      return_qty: [''],
      check: [false],
      purchase_details_id_arr: ['']
    }
  invoice: any;
  medicine: any;
  searching = false;
  searchFailed = false;
  invoice_options: any;
  invoice_data: any;

  medicine_data: any;


  quantity = 0;
  customer: any;

  constructor(private loaderService: LoaderService,
              protected utils: UtilsInjectable,
              public consultingService: ConsultingService,
              public reportService: ReportService,
              private toastr: ToastrService,
  ) {
  }

  ngOnInit() {
    this.user_rights = JSON.parse(localStorage.getItem('user_rights') || "{}");
    this.user_data = JSON.parse(localStorage.getItem('user') || "{}");
    this.listCustomerInvoice()
  }


  public listCustomerInvoice() {
    const opdata = {};
    window.scrollTo(0, 0)
    this.loaderService.display(true);
    this.reportService.listCustomerInvoice(opdata).subscribe((result: any) => {
      this.loaderService.display(false);
      if (result['status'] == 'Success') {
        this.invoice = result['data'];
        this.invoice_options = result['data'];
        for (let index = 0; index < this.invoice_options.length; index++) {
          if (this.invoice_options[index].SALE_ID == this.sale_return.sale_id) {
            this.invoice_data = this.invoice_options[index];
          }
        }
      }
    });
  }

  public setInvoice() {

    for (let index = 0; index < this.invoice.length; index++) {
      if (this.invoice[index].SALE_ID == this.sale_return.sale_id) {
        this.invoice_data = this.invoice[index];
        break;
      }
    }
  }

  public totalAmount() {
    let sum = 0
    this.sale_return.return_qty.forEach((_item: any, index: any): any => {

      if (this.sale_return.check[index] == true) {
        if (parseInt(this.sale_return.quantity_arr[index]) < parseInt(this.sale_return.return_qty[index])) {
          this.toastr.error('Invalid Return quantity');
          return false;

        }
        if (parseInt(this.sale_return.quantity_arr[index]) > 0 && parseInt(this.sale_return.price_arr[index]) > 0) {
          const reqty = parseFloat(this.sale_return.return_qty[index]);
          const price = parseFloat(this.sale_return.unitprice_arr[index]);
          if (!isNaN(reqty)) {
            sum = price * reqty;
          }

          this.sale_return.return_amt[index] = sum.toFixed(2);
          this.total();
        }
      }
    });
  }

  public total() {
    let sum = 0;
    this.sale_return.quantity_arr.forEach((_item: any, index: any): any => {
      if (this.sale_return.check[index] == true) {
        const total = parseFloat(this.sale_return.return_amt[index]);
        if (!isNaN(total)) {
          sum = sum + total
        }
      }
    });
    this.total_amount = sum.toFixed(2);
  }

  public set_item_medicine($event: any, i: any) {
    const item = $event.item;
    this.sale_return.medicine_id_arr[i] = item.MEDICINE_ID;
    this.sale_return.price_arr[i] = item.PRICE;
    this.sale_return.uom_arr_name[i] = item.UNIT_DESC;
    this.sale_return.total_arr[i] = item.TOTAL;
    if (item.AVAILABLE_STOCK_QUANTITY > 0) {
      this.sale_return.ava_quantity_arr[i] = item.AVAILABLE_STOCK_QUANTITY;
    } else {
      this.sale_return.ava_quantity_arr[i] = 0;
    }
    this.sale_return.quantity_arr[i] = item.QUANTITY - item.RETURN_QUANTITY;
    this.sale_return.unitprice_arr[i] = item.UNIT_PRICE;
    this.sale_return.sale_details_id[i] = item.SALE_DETAILS_ID;
    this.sale_return.dis_arr[i] = item.DISCOUNT;
    this.sale_return.sale_details_id_arr[i] = item.sale_details_ID;

  }

  getInvoice() {
    this.sale_return = {
      sale_details_id: [""],
      invoice_date: '',
      return_date: new Date(),
      reference_no: "",
      return_reason: [""],
      state: '',
      sale_id: 0,
      medicine_data: [],
      medicine_id_arr: [""],
      customer_name: '',
      sale_date: new Date(),
      ava_quantity_arr: [""],
      quantity_arr: [""],
      uom_arr: [""],
      uom_arr_name: [""],
      amount_arr: [""],
      price_arr: [""],
      retailprice_arr: [""],
      dis_arr: [""],
      sale_details_id_arr: [""],
      user_id: '',
      total_arr: [""],
      unitprice_arr: [""],
      return_amt: ["0"],
      return_qty: [''],
      check: [false],
      purchase_details_id_arr: ['']


    }

    this.sale_return.sale_id = this.invoice_data.SALE_ID;
    this.date = this.invoice_data.SALE_DATE
    this.sale_return.state = this.invoice_data.STATE_NAME
    this.sale_return.invoice_date = this.utils.date(this.invoice_data.SALE_DATE)
    this.sale_return.customer_name = this.invoice_data.PATIENT_NAME
    this.customer = this.invoice_data.CUSTOMER_NAME
    this.getSale(this.invoice_data.SALE_ID)

  }

  public getSale(sale_id: any) {
    this.clear_sale();
    const postData = {

      sale_id: sale_id
    };
    this.loaderService.display(true);
    window.scrollTo(0, 0);
    this.loaderService.display(true);
    this.reportService.getSaleforReturn(postData).subscribe((result: any) => {
      if (result['status'] == 'Success') {

        let i = 0;
        this.sale_details = ['0'];
        const sale_details = [];
        this.sale_return.patient_name = result['data'].PATIENT_NAME;
        this.sale_return.order_no = result['data'].INVOICE_NUMBER;
        this.sale_return.invoice_date = this.utils.date(result['data'].SALE_DATE);
        this.sale_return.state = result['data'].STATE_NAME;
        this.sale_return.state_id = result['data'].STATE_ID;
        this.sale_return.chequeno = result['data'].CHEQUE_CARD_NUMBER;
        this.sale_return.sale_id = result['data'].SALE_ID;
        this.sale_return.vat_no = result['data'].VAT_NO;
        this.sale_return.remark = result['data'].ONLINE_REMARK;
        this.sale_return.license_no = result['data'].DRUG_LICENSE_NUMBER;
        this.sale_return.shipping_address = result['data'].SHIPPING_ADDRESS;
        this.sale_return.payment_type = result['data'].PAYMENT_TYPE;
        this.sale_return.freight_charge = result['data'].FREIGHT_CHARGE;
        this.sale_return.discount = result['data'].DISCOUNT;
        if (this.sale_return.vat_no) {
          environment.FLOOD_CESS_PERCENTAGE = 0;
        } else {
          environment.FLOOD_CESS_PERCENTAGE = 0;
        }
        for (const val of result['data'].SALE) {
          sale_details.push(i);
          this.sale_return.medicine_data[i] = {
            'MEDICINE_ID': val.MEDICINE_ID,
            'TRADE_NAME': val.TRADE_NAME,
            'DDC_CODE': val.DDC_CODE,
            'SCIENTIFIC_CODE': val.SCIENTIFIC_CODE,
            'SCIENTIFIC_NAME': val.SCIENTIFIC_NAME
          };
          this.sale_return.uom_arr[i] = val.UNIT_ID;
          this.sale_return.uom_arr_name[i] = val.UNIT_DESC;
          this.sale_return.sale_details_id_arr[i] = val.SALE_DETAILS_ID
          this.sale_return.medicine_id_arr[i] = val.MEDICINE_ID
          this.sale_return.ava_quantity_arr[i] = val.AVAILABLE_STOCK_QUANTITY;
          this.sale_return.total_arr[i] = val.TOTAL
          this.sale_return.quantity_arr[i] = val.QUANTITY - val.RETURN_QUANTITY;
          this.sale_return.purchase_details_id_arr[i] = val.PURCHASE_DETAILS_ID;
          this.sale_return.unitprice_arr[i] = val.UNIT_PRICE;
          this.sale_return.price_arr[i] = val.PRICE;
          this.sale_return.check[i] = false;
          i = i + 1;
        }
        this.sale_details = sale_details;

        this.total();
        this.totalAmount();
        this.setInvoice();
        this.loaderService.display(false);
      } else {
        this.loaderService.display(false);
      }
    });
  }

  public addrow(index: any) {
    this.sale_details[index + 1] = '';
    this.sale_return.medicine_data[index + 1] = '';
    this.sale_return.sale_details_id[index + 1] = '';
    this.sale_return.price_arr[index + 1] = '';
    this.sale_return.dis_arr[index + 1] = '';
    this.sale_return.total_arr[index + 1] = '';
    this.sale_return.unitprice_arr[index + 1] = '';
    this.sale_return.quantity_arr[index + 1] = '';
    this.sale_return.ava_quantity_arr[index + 1] = '';
    this.sale_return.return_amt[index + 1] = '';
    this.sale_return.return_qty[index + 1] = '';
    this.sale_return.sale_details_id_arr[index + 1] = '';
  }

  public deleterow(index: any) {
    this.sale_details.splice(index, 1);
    this.sale_return.medicine_data.splice(index, 1);
    this.sale_return.medicine_id_arr.splice(index, 1);
    this.sale_return.price_arr.splice(index, 1);
    this.sale_return.dis_arr.splice(index, 1);
    this.sale_return.total_arr.splice(index, 1);
    this.sale_return.unitprice_arr.splice(index, 1);
    this.sale_return.quantity_arr.splice(index, 1);
    this.sale_return.ava_quantity_arr.splice(index, 1);
    this.sale_return.return_amt.splice(index, 1);
    this.sale_return.return_qty.splice(index, 1);
    this.sale_return.sale_details_id_arr.splice(index, 1);
    this.totalAmount();
  }

  public getToday(): string {
    return new Date().toISOString().split('T')[0]
  }

  public saveReturnSale(): any {

    if (this.sale_return.sale_id == '' || this.sale_return.sale_id == 0) {
      this.toastr.error('Please select Invoice number !');
      return false
    }
    if (this.sale_return.return_date == '') {
      this.toastr.error('Please select Return date !');
      return false
    }
    if (this.sale_return.reference_no == '') {
      this.toastr.error('Please enter Reference number !');
      return false
    }
    let rel = 1;
    let rep = 1;
    this.sale_return.quantity_arr.forEach((_item: any, index: any): any => {
      if (this.sale_return.check[index] == true) {
        if (this.sale_return.return_qty[index] == "") {
          this.toastr.error('Enter Return quantity');
          rel = 0;
          return false;

        }
        if (parseInt(this.sale_return.quantity_arr[index]) < parseInt(this.sale_return.return_qty[index])) {
          this.toastr.error('Invalid Return quantity');
          rel = 0;
          return false;

        }

        if (parseFloat(this.sale_return.total_arr[index]) < parseFloat(this.sale_return.return_amt[index])) {
          this.toastr.error('Invalid Return amount');
          rel = 0;
          return false;
        }
        if (this.sale_return.return_reason[index] == "") {
          this.toastr.error('Please enter Return reason');
          rel = 0;
          return false;

        }
      }
      if (this.sale_return.check[index] == true) {
        rep = 0
      }
    });
    if (rel == 0) {
      return false
    }
    if (rep == 1) {
      this.toastr.error('Please select atleast one item');
      return false
    }

    this.sale_return.user_id = this.user_data.user_id
    this.loaderService.display(true);
    this.reportService.saveReturnSale(this.sale_return).subscribe((result: any) => {
      window.scrollTo(0, 0)
      console.log(result);
      if (result["status"] == "Success") {
        this.loaderService.display(false);
        this.toastr.success(result.msg);
        this.sale_return.puchase_id = result.data_id;
        this.clear_sale();
      } else {
        this.toastr.error(result.msg);
        this.loaderService.display(false);
      }
    })
  }

  public changeCheckbox(i: any) {
    this.sale_return.check[i] = this.sale_return.check[i] != true;
  }

  public clear_sale() {
    this.sale_details = ["0"];
    this.total_amount = 0;
    this.sale_return = {
      vendor_id: '',
      sale_details_id: [""],
      invoice_date: '',
      return_date: new Date(),
      reference_no: "",
      return_reason: [""],
      state: '',
      sale_id: 0,
      medicine_data: [],
      medicine_id_arr: [""],
      customer_name: '',
      sale_date: new Date(),
      ava_quantity_arr: [""],
      quantity_arr: [""],
      uom_arr: [""],
      uom_arr_name: [""],
      amount_arr: [""],
      price_arr: [""],
      retailprice_arr: [""],
      dis_arr: [""],
      sale_details_id_arr: [""],
      user_id: '',
      total_arr: [""],
      unitprice_arr: [""],
      return_amt: ["0"],
      return_qty: [''],
      check: [false],
      purchase_details_id_arr: ['']

    }
    this.invoice_data = ""
  }

  medicine_search = (text$: Observable<string>) =>

    text$.pipe(
      debounceTime(500),
      distinctUntilChanged(),
      tap(() => this.searching = true,),
      switchMap(term =>
        this.consultingService.medicine_sale_search(term, this.sale_return.sale_id).pipe(
          map((response: any) => {
            this.searchFailed = false
            if (response.status == 'Success') {
              return response.data;
            } else {
              return [];
            }
          }),
          catchError(() => {
            this.searchFailed = true;
            return of([])
          })
        )
      ),
      tap(() => this.searching = false)
    )
  formatter = (x: {
    TRADE_NAME: string,
    DDC_CODE: string,
    SCIENTIFIC_NAME: string,
    MEDICINE_ID: number,
    SCIENTIFIC_CODE: number
  }): any => x.TRADE_NAME;
}

